import { useNavigate, useParams } from "react-router";

import { useDialog } from "@datanac/datanac-mui-toolkit";
import { Chip, IconButton } from "@mui/material";
import { CropFieldIcon } from "components/Icons/Icons";
import { formatNumber, formatPracticeName } from "utility/formatters";

import { TilleyCard } from "../../../Cards/TilleyCard";
import { DeleteIcon } from "../../../Icons/Icons";
import { CROP_YEAR_POTENTIAL } from "../helpers";

export default function FieldCard({ producerFarm, producerFarmField, onChange, ...props }) {
  const navigate = useNavigate();
  const { crop_year, location_state_name, location_county_name } = useParams();

  const { component: confirmDialogComponent, actions: confirmDialogActions } = useDialog();
  const handleDeleteOnClick = () => {
    confirmDialogActions.confirm({
      title: "Delete this entry?",
      prompt: "Are you sure you want to delete this field?",
      promptDetail: "Warning: deleting a field removes crops from ALL YEARS.",
      callback: () => {
        const _newState = { ...producerFarmField };
        _newState.is_active = false;
        onChange?.(_newState);
      },
    });
  };

  return (
    <>
      <TilleyCard
        {...props}
        data-testid={`Open-Field-${producerFarmField?.fsa_tract_number}-${producerFarmField?.fsa_field_number}`}
        onClick={
          crop_year !== CROP_YEAR_POTENTIAL
            ? () =>
                navigate(
                  `/vault/${crop_year}/${location_state_name}/${location_county_name}/${producerFarm?.id}/${producerFarmField?.id}`
                )
            : undefined
        }
        Avatar={CropFieldIcon}
        title={"Tract " + producerFarmField?.fsa_tract_number}
        subtitle={"Field " + producerFarmField?.fsa_field_number}
        action={
          crop_year === CROP_YEAR_POTENTIAL ? (
            <IconButton
              data-testid={`Delete-Field-${producerFarmField?.fsa_tract_number}-${producerFarmField?.fsa_field_number}`}
              onClick={(e) => {
                e.stopPropagation();
                handleDeleteOnClick();
              }}
            >
              <DeleteIcon />
            </IconButton>
          ) : null
        }
        details={[
          {
            value: formatNumber(producerFarmField?.reported_acreage, 0),
            label: "ACRES",
          },
        ]}
        footer={
          <>
            {producerFarmField?.CropProfiles?.map((currentCropProfile, index) => (
              <Chip
                key={index}
                label={currentCropProfile?.commodity_name + " " + formatPracticeName(currentCropProfile?.practice_name)}
              />
            ))}
          </>
        }
      />
      {confirmDialogComponent}
    </>
  );
}
